/*
 * Filtra la galería de medios del producto según las opciones visuales
 * seleccionadas (Color, Correa, Acabado, Caja, Material…).
 * Cada imagen lleva en su "alt" el/los valores a los que pertenece
 * (p. ej. "iPhone 17 Pro Max Azul" o "Apple Watch Ultra 3 Titanio Negro Ocean").
 * Al elegir una opción, se ocultan las imágenes de los demás valores de ese grupo.
 * Las imágenes sin ningún valor de un grupo en el alt se mantienen visibles.
 */
(function () {
  'use strict';

  var VISUAL_LABEL = /(color|colour|correa|acabado|material|caja|band|strap|finish|versi[oó]n|edici[oó]n)/i;

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  function getVisualFieldsets(scope) {
    var sets = scope.querySelectorAll('fieldset, .product-form__input');
    var out = [];
    for (var i = 0; i < sets.length; i++) {
      var label = sets[i].querySelector('legend, .form__label');
      if (label && VISUAL_LABEL.test(label.textContent)) out.push(sets[i]);
    }
    return out;
  }

  function selectedValue(fs) {
    var checked = fs.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (checked) return norm(checked.value);
    var sel = fs.querySelector('select');
    if (sel) return norm(sel.value);
    return null;
  }

  function allValues(fs) {
    var out = [];
    fs.querySelectorAll('input[type="radio"], input[type="checkbox"], option').forEach(function (el) {
      var v = norm(el.value);
      if (v) out.push(v);
    });
    return out;
  }

  function apply(section) {
    if (section.querySelector('media-gallery [data-oh-color-catalog]')) return;
    var fieldsets = getVisualFieldsets(section);
    if (!fieldsets.length) return;

    // Un grupo por cada opción visual: { sel, values }
    var grps = [];
    fieldsets.forEach(function (fs) {
      var sel = selectedValue(fs);
      var values = allValues(fs);
      if (sel && values.length) grps.push({ sel: sel, values: values });
    });
    if (!grps.length) return;

    var lists = [
      section.querySelectorAll('.product__media-item, .product-media-container, [data-media-id].slider__slide'),
      section.querySelectorAll('.thumbnail-list__item, .thumbnail-list li, [id^="Slide-Thumbnails-"] li')
    ];

    var firstVisibleThumb = null;
    var firstVisibleMedia = null;

    lists.forEach(function (list) {
      list.forEach(function (item) {
        var img = item.querySelector('img');
        var alt = norm(img && img.getAttribute('alt'));
        // Se muestra solo si, para cada grupo, el alt no menciona ningún
        // valor del grupo, o menciona justamente el valor seleccionado.
        var show = grps.every(function (g) {
          var mentioned = g.values.filter(function (v) { return v && alt.indexOf(v) !== -1; });
          return mentioned.length === 0 || mentioned.indexOf(g.sel) !== -1;
        });
        item.hidden = !show;
        item.style.display = show ? '' : 'none';
        if (show && item.matches('.product__media-item')) {
          item.classList.remove('product__media-item--variant');
          if (!firstVisibleMedia) firstVisibleMedia = item;
        }
        if (show && item.matches('.thumbnail-list__item, .thumbnail-list li')) {
          item.classList.remove('thumbnail-list_item--variant');
          if (!firstVisibleThumb) firstVisibleThumb = item;
        }
      });
    });

    var gallery = section.querySelector('media-gallery');
    var activeMedia = gallery && gallery.querySelector('.product__media-item.is-active');
    if (firstVisibleMedia && (!activeMedia || activeMedia.hidden || activeMedia.style.display === 'none')) {
      firstVisibleMedia.classList.remove('scroll-trigger--offscreen');
      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(firstVisibleMedia.dataset.mediaId, true);
      } else if (firstVisibleThumb) {
        var button = firstVisibleThumb.querySelector('button');
        if (button) button.click();
      }
    }
    if (gallery) {
      gallery.querySelectorAll('slider-component').forEach(function (slider) {
        if (typeof slider.resetPages === 'function') slider.resetPages();
      });
    }
  }

  // ¿El cambio agrega o quita elementos (no solo texto)? El contador del
  // carrusel de Dawn («1 / 5») cambia texto en cada scroll y en cada
  // resetPages(); si eso disparara apply() otra vez, se arma un bucle infinito.
  function addsOrRemovesElements(records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.target && r.target.closest && r.target.closest('.slider-counter')) continue;
      var nodes = [r.addedNodes, r.removedNodes];
      for (var n = 0; n < nodes.length; n++) {
        for (var j = 0; j < nodes[n].length; j++) {
          if (nodes[n][j].nodeType === 1) return true;
        }
      }
    }
    return false;
  }

  function bind(section) {
    // Dawn anida <product-info>, .product y #MainProduct-…: una sola vigilancia por galería.
    var gallery = section.querySelector('media-gallery, .product__media-wrapper');
    var key = gallery || section;
    if (key.__ohColorGallery) return;
    key.__ohColorGallery = true;

    var scheduled = false;
    var observer = null;
    var watch = function () {
      if (observer) observer.observe(gallery, { childList: true, subtree: true });
    };
    var run = function () {
      scheduled = false;
      // Lo que apply() cambia en la galería (orden de fotos, contador del
      // carrusel) no debe volver a dispararlo: se deja de observar mientras corre.
      if (observer) observer.disconnect();
      try {
        apply(section);
      } finally {
        watch();
      }
    };
    // Varios avisos en el mismo cuadro se juntan en una sola pasada.
    var runner = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(run);
    };

    // En fase de captura y al instante: la foto del color elegido tiene que estar
    // visible antes de que Dawn (updateMedia → setActiveMedia) intente activarla;
    // media-gallery.js no activa una foto con hidden.
    section.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form__input, variant-selects, variant-radios')) run();
    }, true);
    // Dawn reordena la galería al cambiar de variante.
    if (gallery && window.MutationObserver) {
      observer = new MutationObserver(function (records) {
        if (addsOrRemovesElements(records)) runner();
      });
      watch();
    }
    runner();
  }

  function init() {
    var sections = document.querySelectorAll('.product, product-info, [id^="MainProduct-"]');
    if (!sections.length) return;
    sections.forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


